const productCardList = document.querySelector('.product-card-list');

if (productCardList) {
  let latestRequestId = 0;

  /* ----------------------------------------
   * Helpers
   * ------------------------------------- */

  const getParent = (el) => el.closest('.product-card-list');

  const getSearchTerm = (parent) =>
    parent.querySelector('.product-card-list__search-bar .mod-input__field')?.value.trim() || '';

  const getPageNumber = (parent) => Number(parent.dataset.page) || 1;

  const setPageNumber = (parent, pageNumber) => {
    parent.dataset.page = String(pageNumber);
  };

  const toggleLoadMore = (parent, hasMore) => {
    const loadMoreBtn = parent.querySelector('.product-card-list__load-more');

    if (!loadMoreBtn || typeof hasMore === 'undefined') {
      return;
    }

    loadMoreBtn.classList.toggle('hide', !hasMore);
  };

  const updateListHtml = (parent, html, loadMore) => {
    const loadMoreBtn = parent.querySelector('.product-card-list__load-more');

    if (loadMore) {
      if (loadMoreBtn && html) {
        loadMoreBtn.insertAdjacentHTML('beforebegin', html);
      }

      return;
    }

    parent.querySelectorAll('.product-card-list__inner .product-card').forEach((card) => {
      card.remove();
    });

    if (html && loadMoreBtn) {
      loadMoreBtn.insertAdjacentHTML('beforebegin', html);
    }
  };

  /* ----------------------------------------
   * Axios
   * ------------------------------------- */

  const fetchProductCardList = async ({ parent, searchTerm, pageNumber, loadMore = false }) => {
    const requestId = ++latestRequestId;
    const action = parent.querySelector('[data-action]')?.value || 'getProductCardList';
    const section = parent.querySelector('[data-section]')?.value;
    const listWrap = parent.querySelector('.product-card-list__inner');
    const notFound = parent.querySelector('.product-card-list__not-found');
    const notFoundTitle = parent.querySelector('.product-card-list__not-found-title');
    const emptyTitleDefault = notFoundTitle?.dataset.emptyTitleDefault || notFoundTitle?.textContent?.trim() || '';

    if (notFoundTitle && !notFoundTitle.dataset.emptyTitleDefault) {
      notFoundTitle.dataset.emptyTitleDefault = emptyTitleDefault;
    }

    try {
      const { data } = await axios.post(localData.siteURL, {
        action,
        section,
        searchTerm,
        pageNumber,
        loadMore,
        exclude: parent.querySelector('.product-card-list__exclude')?.value || '',
        pageId: parent.querySelector('.product-card-list__page-id')?.value || '',
        nonce: await getNonceForAction(action),
      });

      if (requestId !== latestRequestId || getSearchTerm(parent) !== searchTerm) {
        return;
      }

      const hasResults = data?.data?.has_results ?? Boolean(data?.data?.html_list);

      if (loadMore) {
        updateListHtml(parent, data?.data?.html_list, true);
      } else if (hasResults && data?.data?.html_list) {
        updateListHtml(parent, data.data.html_list, false);

        listWrap?.classList.remove('hide');
        notFound?.classList.add('hide');

        if (notFoundTitle && emptyTitleDefault) {
          notFoundTitle.textContent = emptyTitleDefault;
        }
      } else {
        updateListHtml(parent, '', false);

        listWrap?.classList.add('hide');
        notFound?.classList.remove('hide');

        if (notFoundTitle) {
          notFoundTitle.textContent = data?.data?.empty_title || `${emptyTitleDefault} “${searchTerm}”`;
        }
      }

      toggleLoadMore(parent, data?.data?.has_more);

      if (!loadMore && searchTerm.length >= 3) {
        scrollTop(parent.closest('[data-component="mod-product-card-list"]') || parent);
      }
    } catch (error) {
      if (requestId === latestRequestId) {
        console.error(error);
      }
    }
  };

  const debouncedSearch = debounce((parent, searchTerm) => {
    fetchProductCardList({
      parent,
      searchTerm,
      pageNumber: getPageNumber(parent),
      loadMore: false,
    });
  }, 300);

  /* ----------------------------------------
   * Event Handlers
   * ------------------------------------- */

  const handleSearchInput = (ev) => {
    const parent = getParent(ev.target);
    const searchTerm = ev.target.value.trim();

    setPageNumber(parent, 1);

    if (searchTerm.length >= 3) {
      debouncedSearch(parent, searchTerm);
      return;
    }

    if (searchTerm.length === 0) {
      latestRequestId += 1;

      fetchProductCardList({
        parent,
        searchTerm: '',
        pageNumber: 1,
        loadMore: false,
      });
    }
  };

  const handleLoadMore = (ev) => {
    ev.preventDefault();

    const parent = getParent(ev.target);
    const nextPage = getPageNumber(parent) + 1;

    setPageNumber(parent, nextPage);

    fetchProductCardList({
      parent,
      searchTerm: getSearchTerm(parent),
      pageNumber: nextPage,
      loadMore: true,
    });
  };

  /* ----------------------------------------
   * Events
   * ------------------------------------- */

  attachEvent('.product-card-list .product-card-list__search-bar .mod-input__field', 'input', handleSearchInput);
  attachEvent('.product-card-list .product-card-list__load-more', 'click', handleLoadMore);
}
